import { Offcanvas } from "react-bootstrap";
import { AuthTrackingRecord } from "../authTrackingData";
import AuthTrackingDetails from "./AuthTrackingDetails";

interface AuthDetailPanelProps {
  show: boolean;
  auth: AuthTrackingRecord | null;
  onClose: () => void;
}

const AuthDetailPanel = ({ show, auth, onClose }: AuthDetailPanelProps) => {
  return (
    <Offcanvas
      show={show}
      onHide={onClose}
      placement="end"
      className="at-detail-offcanvas"
      aria-labelledby="auth-detail-panel-title"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title id="auth-detail-panel-title">
          Tracking Details
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        {auth ? (
          <>
            <AuthTrackingDetails auth={auth} resetKey={show} />
            <div className="at-detail-footer">
              <button
                type="button"
                className="btn btn-border-primary"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </>
        ) : null}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AuthDetailPanel;
